import React, { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../firebase";
import Header from "../Header";
import Footer from "../Footer";
import "./Auth.css";

function ForgotPassword({ switchToLogin }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [emailSent, setEmailSent] = useState("");

  const handleResetPassword = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setError("Please enter your email address");
      return;
    }

    try {
      setLoading(true);
      setError("");
      setSuccess(false);
      
      console.log("🔄 Sending password reset email to:", email);
      
      await sendPasswordResetEmail(auth, email, {
        url: window.location.origin + '/login',
        handleCodeInApp: false
      });
      
      console.log("✅ Password reset email sent successfully");
      setSuccess(true);
      setEmailSent(email);
      
    } catch (error) {
      console.error("❌ Password reset error:", error);
      
      if (error.code === 'auth/user-not-found') {
        setError("No account found with this email address.");
      } else if (error.code === 'auth/invalid-email') {
        setError("Invalid email address format.");
      } else if (error.code === 'auth/too-many-requests') {
        setError("Too many requests. Please try again later.");
      } else if (error.code === 'auth/network-request-failed') {
        setError("Network error. Please check your connection.");
      } else {
        setError("Failed to send reset email. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-background"></div>
      <div className="auth-content">
        <Header />
        <div className="auth-wrapper">
          <div className="auth-box">
            <h2>Reset Password</h2>
            <p className="auth-subtitle">
              Enter your email address and we'll send you a link to reset your password.
            </p>
            
            {error && <div className="error-message">{error}</div>}
            
            {success ? (
              <div className="success-message">
                <p style={{ margin: '0 0 0.5rem 0', fontWeight: '600', color: 'white' }}>
                  ✓ Email Sent Successfully!
                </p>
                <p style={{ margin: '0', fontSize: '0.95rem', color: 'rgba(255, 255, 255, 0.9)' }}>
                  We've sent a password reset link to <strong>{emailSent}</strong>. 
                  Please check your inbox and follow the instructions.
                </p>
                <p style={{ margin: '0.75rem 0 0 0', fontSize: '0.85rem', color: 'rgba(255, 255, 255, 0.7)' }}>
                  <em>Didn't receive the email? Check your spam folder or try again.</em>
                </p>
              </div>
            ) : (
              <form onSubmit={handleResetPassword}>
                <div className="input-group">
                  <input 
                    type="email" 
                    placeholder="Enter your registered email" 
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="auth-input"
                    required
                    disabled={loading}
                    autoFocus
                  />
                </div>
                
                <button 
                  type="submit"
                  disabled={loading}
                  className="auth-button"
                >
                  {loading ? "Sending Reset Link..." : "Send Reset Link"}
                </button>
              </form>
            )}
            
            <div className="auth-switch">
              <p style={{ margin: 0 }}>
                <button 
                  type="button"
                  onClick={switchToLogin} 
                  className="switch-link"
                  disabled={loading}
                >
                  ← Back to Sign In
                </button>
              </p>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default ForgotPassword;